// Matches UserPermission definition in backend
export enum UserPermission {
  AdminAccess,
  CoreMemberAccess,
  CapgeminiAccess,
  UserAccess,
}
